import React, { useState } from "react";
import { DropdownList, OptionType } from "elements";
import { useUpdatePolicyPriorityMutation } from "generated/graphql";
import { DISMISS, useNotification } from "collections";
import { useTranslation } from "utilities/i18n";

export const PriorityDropdown: React.FC<{
  policies: Array<{
    priority: string;
    id: string;
  }>;
}> = ({ policies }) => {
  const [, updatePolicy] = useUpdatePolicyPriorityMutation();
  const [addNotification] = useNotification();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const onPriorityChange = async (newPriority: string) => {
    setLoading(true);
    const errors = [];

    for (const policy of policies) {
      const result = await updatePolicy({
        id: policy.id,
        priority: newPriority
      });
      if (result.error) errors.push(result.error);
    }

    setLoading(false);

    if (errors.length) {
      addNotification({
        type: "error",
        dismiss: DISMISS.DEFAULT,
        message: t("POLICY_PRIORITY_UPDATE_ERROR", {
          message: errors[0].message
        })
      });
    }
  };

  const options: Array<OptionType> = [
    {
      value: "0.1",
      text: t("CRITICAL")
    },
    {
      value: "0.2",
      text: t("IMPORTANT")
    },
    {
      value: "0.3",
      text: t("NORMAL")
    },
    {
      value: "0.4",
      text: t("LOW")
    },
    {
      value: "0.5",
      text: t("LOWEST")
    }
  ];
  const textFromValue = (value: string) => {
    return options.find(option => option.value === value)?.text ?? t("NORMAL");
  };

  const hasPolicy = !!policies?.length;

  const value = hasPolicy ? policies[0].priority : "0.3";

  return (
    <div className="form-input">
      <DropdownList
        name="Priority"
        value={textFromValue(value)}
        onChange={onPriorityChange}
        disabled={!hasPolicy || loading}
        options={options}
      />
    </div>
  );
};
